//重写threebox的读取模型部分，用于读取obj模型

import utils from "threebox-plugin/src/utils/utils.js";
import Objects from "threebox-plugin/src/objects/objects.js";
import OBJLoader from "threebox-plugin/src/objects/loaders/OBJLoader.js";
import MTLLoader from "threebox-plugin/src/objects/loaders/MTLLoader.js";
import FBXLoader from "threebox-plugin/src/objects/loaders/FBXLoader.js";
import GLTFLoader from "threebox-plugin/src/objects/loaders/GLTFLoader.js";
import ColladaLoader from "threebox-plugin/src/objects/loaders/ColladaLoader.js";
const objLoader = new OBJLoader();
const materialLoader = new MTLLoader();
const gltfLoader = new GLTFLoader();
const fbxLoader = new FBXLoader();
const daeLoader = new ColladaLoader();
import {Color} from "three";


function loader(options, cb, promise) {

	if (options === undefined) return console.error("Invalid options provided to loadObj()");
	options = utils._validate(options, Objects.prototype._defaults.loadObj);

	let loader;
	if (!options.type) {
		options.type = 'mtl';
	}
	//[jscastro] support other models
	switch (options.type) {
		case "mtl":
			loader = objLoader;
			break;
		case "gltf":
		case "glb":
			// [jscastro] Support for GLTF/GLB
			loader = gltfLoader;
			break;
		case "fbx":
			loader = fbxLoader;
			break;
		case "dae":
			loader = daeLoader;
			break;
	}


	//[jscastro] some FBX/GLTF models have too much specular effects for mapbox
	function normalizeSpecular(model) {
		model.traverse(function (c) {

			if (c.isMesh) {
				//c.castShadow = true;
				let specularColor;
				if (c.material.type === 'MeshStandardMaterial') {

					if (c.material.metalness) { c.material.metalness *= 0.1; }
					if (c.material.glossiness) { c.material.glossiness *= 0.25; }
					specularColor = new Color(12, 12, 12);

				} else if (c.material.type === 'MeshPhongMaterial') {
					c.material.shininess = 0.1;
					specularColor = new Color(20, 20, 20);
				}
				if (c.material.specular && c.material.specular.isColor) {
					c.material.specular = specularColor;
				}
				//c.material.needsUpdate = true;

			}

		});
	}

	function loadObject(materials) {

		if (materials && options.type === "mtl") {
			materials.preload();
			loader.setMaterials(materials);
		}

		loader.load(options.obj, obj => {

			//[jscastro] MTL/GLTF/FBX models have a different structure
			let animations = [];
			switch (options.type) {
				case "mtl":
					//此处修改，使obj可以读取所有子模型
					// obj = obj.children[0];
					break;
				case "gltf":
				case "glb":
				case "dae":
					animations = obj.animations;
					obj = obj.scene;
					break;
				case "fbx":
					animations = obj.animations;
					break;
			}
			obj.animations = animations;
			// [jscastro] options.rotation was wrongly used
			const r = utils.types.rotation(options.rotation, [0, 0, 0]);
			const s = utils.types.scale(options.scale, [1, 1, 1]);
			obj.rotation.set(r[0], r[1], r[2]);
			obj.scale.set(s[0], s[1], s[2]);
			// [jscastro] normalize specular/metalness/shininess from meshes in FBX and GLB model as it would need 5 lights to illuminate them properly
			if (options.normalize) { normalizeSpecular(obj); }
			obj.name = "model";
			const userScaleGroup = Objects.prototype._makeGroup(obj, options);
			Objects.prototype._addMethods(userScaleGroup);
			//[jscastro] calculate automatically the pivotal center of the object
			userScaleGroup.setAnchor(options.anchor);
			//[jscastro] override the center calculated if the object has adjustments
			userScaleGroup.setCenter(options.adjustment);
			//[jscastro] if the object is excluded from raycasting
			userScaleGroup.raycasted = options.raycasted;
			//[jscastro] return to cache
			promise(userScaleGroup);
			//[jscastro] then return to the client-side callback
			cb(userScaleGroup);
			//[jscastro] apply the fixed zoom scale if needed
			userScaleGroup.setFixedZoom(options.mapScale);
			//[jscastro] initialize the default animation to avoid issues with skeleton position
			userScaleGroup.idle();

		}, () => null, error => {
				console.error("Could not load model file: " + options.obj + " \n " + error.stack);
				promise("Error loading the model");
		});

	}

	materialLoader.load(options.mtl, loadObject, () => null, error => {
		console.warn("No material file found " + error.stack);
	});

}

export async function loadObj(tb, options, cb) {
	tb.setDefaultView(options, tb.options);
	if (options.clone === false) {
		return new Promise(
			(resolve) => {
				loader(options, cb, async (obj) => {
					resolve(obj);
				});
			});
	}
	else {
		//[jscastro] new added cache for 3D Objects
		const cache = tb.objectsCache.get(options.obj);
		if (cache) {
			cache.promise
				.then(obj => {
					cb(obj.duplicate(options));
				})
				.catch(err => {
					tb.objectsCache.delete(options.obj);
					console.error("Could not load model file: " + options.obj);
				});
		} else {
			tb.objectsCache.set(options.obj, {
				promise: new Promise(
					(resolve, reject) => {
						loader(options, cb, async (obj) => {
							if (obj.duplicate) {
								resolve(obj.duplicate());
							} else {
								reject(obj);
							}
						});
					})
			});

		}
	}
}
